module.exports = __webpack_public_path__ + "img/jiu1.d9f08578.png";